import { SecurityFieldsType } from '..';

export const createSecurity = (orderNumber: number): SecurityFieldsType => {
  return {
    orderNumber: orderNumber,
    fisn: '',
    isin: '',
    cfiCode: '',
    type: '',
    offerEndDate: undefined as any,
    issuanceCurrency: '',
    typeOfOfferAdmission: '',
    memberStateAdmissionToTrading: undefined,
    memberStateOfferToPublic: undefined,
    tradingVenueCharacteristics: undefined,
  };
};
